import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {Trial} from '../../model/trial';
import {DateUtil} from '../../shared/utils/Date/date-util';
import {PriceDetail} from '../../model/ocapi/price-detail';

export class DtvCatalogUtils {
  public static getPriceForProduct(packs: TvShopEntertainmentPack[], omapiId: string): PriceDetail {
    const pack: TvShopEntertainmentPack = packs.filter((p: TvShopEntertainmentPack) => p.omapiId === omapiId).pop();
    return (pack !== undefined) ? pack.priceDetail : undefined;
  }

  public static getTvShopEntertainmentPackForOmapiId(packs: TvShopEntertainmentPack[], omapiId: string): TvShopEntertainmentPack {
    return packs.filter(this.findPacksWithOmapiId(omapiId)).pop();
  }

  public static getStreamingServicesOptionForOmapiId(streamingServicesPacks: TvShopEntertainmentPack[], omapiId: string): TvShopEntertainmentPack {
    return streamingServicesPacks.filter(this.findPacksWithOmapiId(omapiId)).pop();
  }

  private static findPacksWithOmapiId(omapiId: string) {
    return pack => pack.omapiId === omapiId;
  }

  public static onTrialActivated(packs: TvShopEntertainmentPack[], trial: Trial) {
    if (!trial) {
      return;
    }
    const trialPack = packs.filter(this.findPacksWithOmapiId(trial.omapiId)).pop();
    const parentPack = packs.filter(this.findPacksWithOmapiId(trial.parentOmapiId)).pop();
    if (trialPack) {
      trialPack.subscribed = true;
      trialPack.endDate = DateUtil.getTrialEndDate(trial);
    }
    if (parentPack) {
      parentPack.hasTrial = true;
    }
  }
}
